var _rect, _rect2, _rect3, _rect4, _rect5, _rect6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBxList(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6.73926,
    y: 5,
    width: 15.9565,
    height: 2,
    rx: 1,
    fill: "#F1F1F1"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 6.73926,
    y: 11.3477,
    width: 15.9565,
    height: 2,
    rx: 1,
    fill: "#F1F1F1"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 6.73926,
    y: 17.6953,
    width: 15.9565,
    height: 2,
    rx: 1,
    fill: "#F1F1F1"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 5,
    width: 2,
    height: 2,
    rx: 1,
    fill: "#F1F1F1"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 11.3477,
    width: 2,
    height: 2,
    rx: 1,
    fill: "#F1F1F1"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 17.6953,
    width: 2,
    height: 2,
    rx: 1,
    fill: "#F1F1F1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBxList);
export default __webpack_public_path__ + "static/media/Bx-list.4de4c50523340f40078cd23091366afc.svg";
export { ForwardRef as ReactComponent };